import useCurrency from '@hooks/item/useCurrency';
import { CreateOrderRequest } from '@models/order';
import { pushEcommerceEvent, purchaseToGtmFormat } from '@utils/gtm';
import { getTempOrder } from '@utils/restoreOrderUtils';

/**
 * 결제 성공 시 purchase 이벤트를 발화한다.
 * order 를 넘기지 않으면 결제 전 저장한 임시 주문(tempOrder)을 사용한다. (PG 리다이렉트 후에는 주문 상태가 없음)
 * 임시 주문을 삭제하기 전에 호출해야 한다.
 */
function usePurchase() {
    const currency = useCurrency();

    return async (orderNo: string, order?: CreateOrderRequest) => {
        try {
            const purchasedOrder = order || await getTempOrder('ORDER');
            if (!purchasedOrder) return;
            pushEcommerceEvent('purchase', purchaseToGtmFormat({
                orderNo, order: purchasedOrder, currency,
            }));
        } catch (e) {
            console.error(e);
        }
    };
}

export default usePurchase;
